import React, {useEffect, useState} from "react";
import deleteAccountBg from "../../assets/img/background_delete_account.png";
import {FormattedMessage} from "react-intl";
import backImg from "../../assets/img/icon_back.svg";
import iconSadFace from "../../assets/img/icon_sadface.svg";
import analyticsLogEvent from "../../services/FirebaseService";
import {FIREBASE_SCREEN_NAMES} from "../../util/Constants";
import Spinner from "../../components/Spinner";

import * as AccountService from "../../services/AccountService";
import {PATH} from "../../routes/routes";
import {removeUserInfoFromStorage} from "../../util/common";
import {useNavigate} from "react-router";

function ProfileDelete() {
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";
    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
        isSubmitBtnEnabled: true,
        confirmDeleteModalStyle: hidden
    });


    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.PROFILE_DELETE,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.PROFILE_DELETE
        });
    }, []);


    const goBack = () => {
        navigateTo(-1)
    }


    const deleteAccount = async () => {
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
        })


        if (!state.isSubmitBtnEnabled || state.loading) {
            return;
        }

        const response = await AccountService.deleteAccount();
        if (response.ok) {
            setState({
                ...state,
                loading: false,
                isSubmitBtnEnabled: false,
                errorMsg: null,
            })

            removeUserInfoFromStorage();
            navigateTo(PATH.MAIN);
        } else {
            if (response.data.code === 403) {
                setState({
                    ...state,
                    errorMsg: response.data.error,
                    loading: false,
                })
            } else {
                setState({
                    ...state,
                    errorMsg: <FormattedMessage id="Error.genericError"/>,
                    loading: false,
                })
            }
        }
    }

    let pageStyle = {
        backgroundImage: "url(" + deleteAccountBg + ")",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat"
    };

    const openConfirmDeleteModal = () => {
        setState({
            ...state,
            confirmDeleteModalStyle: visible
        })
    }

    const closeConfirmDeleteModal = () => {
        setState({
            ...state,
            confirmDeleteModalStyle: hidden
        })
    }


    return (
        <div style={pageStyle} className="page-content delete-account-page-content">

            <div className={state.confirmDeleteModalStyle + " modal-overlay "}
                 onClick={(e) => closeConfirmDeleteModal()}></div>
            <div className="modal" data-qa="delete-profile-alert-modal">
                <div className="row">
                    <div className="modal-title"><FormattedMessage id="DoYouWantToDeleteYourAccount"/></div>
                </div>
                <div className="row">
                    <p className="modal-text"><FormattedMessage id="YouWillLoseAllYourVouchersEtc"/></p>
                </div>




                <div className="row buttons-row">
                    <a className=" btn btn-link btn-md" onClick={() => closeConfirmDeleteModal()} data-qa="delete-profile-cancel-delete"><FormattedMessage
                        id="Cancel"/></a>
                    <a className=" btn btn-link btn-danger no-underline no-border btn-md"
                       onClick={() => deleteAccount()} data-qa="delete-profile-delete-btn"><FormattedMessage id="Delete"/></a>
                </div>
            </div>


            <div className="delete-account-container">
                <a className="btn-back" onClick={goBack} data-qa="delete-profile-back-btn"><img alt="back button" src={backImg}/></a>

                <br/>

                <div className="delete-account-container-content">

                    <div className="row">
                        <img src={iconSadFace}/>
                    </div>
                    <div className="row">
                        <FormattedMessage id="DeleteAccount.Row1"/>
                    </div>
                    <div className="row">
                        <FormattedMessage id="DeleteAccount.Row2"/>
                    </div>
                </div>


                <div className="row delete-row">
                    <button onClick={() => openConfirmDeleteModal()}
                            className={state.isSubmitBtnEnabled ?
                                "btn btn-xl btn-danger uppercase delete-btn"
                                : "btn btn-xl btn-danger uppercase delete-btn btn-disabled"}
                            data-qa="delete-profile-open-delete-confirmation-modal-btn">
                        <FormattedMessage id="Delete" defaultMessage="Delete"/>
                    </button>
                </div>


                {state.loading ?
                    <div className="spinner" data-qa="spinner"><Spinner/></div>
                    : null
                }

                {state.errorMsg != null ?
                    <div className="error-div" data-qa="delete-profile-error-div">
                        <p>&#9888;&nbsp;{state.errorMsg}</p>
                    </div>
                    : null
                }
            </div>
        </div>

    );
}

export default ProfileDelete;
